import './styles/index.css';
import { mountAnalytics } from './analytics.ts';
import { mountChat } from './chat.ts';
import { mountGoogleAnalytics } from './ga.ts';
import { mountIntake } from './intake/view.ts';
import { track } from './lib/telemetry.ts';
import { mountTurnstile } from './turnstile.ts';

mountAnalytics();
mountGoogleAnalytics();

const chat = document.getElementById('answer');
if (chat) mountChat(chat);

const form = document.getElementById('intake') as HTMLFormElement | null;
if (form) {
  mountIntake(form);
  const ts = form.querySelector<HTMLElement>('[data-el="turnstile"]');
  if (ts) mountTurnstile(ts);
  const input = form.querySelector<HTMLInputElement>('[data-el="fileInput"]');
  input?.addEventListener('change', () => form.scrollIntoView({ behavior: 'smooth', block: 'center' }));
  // The "Choose PDF manuals" buttons are labels for the file input; count them as picker opens.
  for (const label of document.querySelectorAll<HTMLLabelElement>('label[for="nl-file"]')) {
    label.addEventListener('click', () => track('intake_picker_opened', { via: 'button', placement: form.contains(label) ? 'card' : 'page' }));
  }
}

// Which questions people open.
for (const d of document.querySelectorAll<HTMLDetailsElement>('.faq details')) {
  d.addEventListener('toggle', () => { if (d.open) track('faq_opened', { question: d.querySelector('summary')?.textContent?.trim() ?? '' }); });
}

// How far down the page people get: each section once, when 40% of it is on screen.
const sections: [string, Element | null][] = [
  ['what_your_team_gets', document.querySelector('[aria-labelledby="gets-title"]')],
  ['chat_demo', chat],
  ['faq', document.querySelector('.faq')],
];
if ('IntersectionObserver' in window) {
  const seen = new Set<Element>();
  const io = new IntersectionObserver((entries) => {
    for (const e of entries) {
      if (!e.isIntersecting || seen.has(e.target)) continue;
      seen.add(e.target); io.unobserve(e.target);
      track('section_viewed', { section: sections.find(([, el]) => el === e.target)?.[0] ?? '' });
    }
  }, { threshold: 0.4 });
  for (const [, el] of sections) if (el) io.observe(el);
}

for (const a of document.querySelectorAll<HTMLAnchorElement>('a[href*="login"]')) {
  a.addEventListener('click', () => track('login_clicked', { placement: a.closest('header') ? 'header' : 'footer' }));
}

const year = document.querySelector<HTMLElement>('[data-el="year"]');
if (year) year.textContent = String(new Date().getFullYear());
